<template>
  <div>
    <v-simple-table dense>
      <thead>
        <tr>
          <th align='left'>Date</th>
          <th align='left'>JE Num.</th>
          <th align='left'>Description</th>
          <th width='36'></th>
          <th align='right'>Debits</th>
          <th align='right'>Credits</th>
        </tr>
      </thead>
      <tbody v-if='transactions.length > 0'>
        <tr v-for='t in transactions' :key='t.id'>
          <td>{{ t.journal_entry_data.posting_date | shortDate }}</td>
          <td>
            <a @click='openJE(t.journal_entry_data)'>JE#: {{ t.journal_entry_data.id }}</a></td>
          <td>
            {{ t.journal_entry_data.description }}
          </td>
          <td width='36' align='center'>
            <v-icon
              v-if='!hideCheckbox && t.is_count_profit_loss'
              :color='uncheckedIds.has(t.id) ? "grey lighten-1" : "success"'
              @click='toggleCheck(t.id)'
              style='cursor: pointer'
            >{{ uncheckedIds.has(t.id) ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-marked' }}</v-icon>
            <v-chip v-if='t.journal_entry_data.reversing_entry' small outlined color='warning'>Reversing</v-chip>
          </td>
          <td align='right' :width='amountWidth'>{{ getAmountDisplay(t.debit) }}</td>
          <td align='right' :width='amountWidth'>{{ getAmountDisplay(t.credit) }}</td>
        </tr>
        <tr>
          <td style='border-top: solid 1px black'></td>
          <td style='border-top: solid 1px black'></td>
          <td style='border-top: solid 1px black'></td>
          <td class='font-weight-bold' align='right' style='border-top: solid 1px black'>TOTALS</td>
          <td class='font-weight-bold' align='right' :width='amountWidth' style='border-top: solid 1px black'>{{ getAmountDisplay(totalDebits) }}</td>
          <td class='font-weight-bold' align='right' :width='amountWidth' style='border-top: solid 1px black'>{{ getAmountDisplay(totalCredits) }}</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td class='font-weight-bold' align='right'>ACCOUNT BALANCE</td>
          <td class='font-weight-bold' align='right' :width='amountWidth * 2' colspan='2'>{{ accountBalance | decAccounting }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td class='grey--text'>
            No transactions found...
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <je-dialog
      v-if='jeDetails'
      :showDialog='showJE'
      :journalEntry='selectedJournalEntry'
      :lines='jeDetails'
      @close='showJE = false'
    ></je-dialog>
  </div>
</template>

<script>
import JournalEntryDialog from './JournalEntryDialog';
import bookkeepingAPI from '@/api/accounting';
import miscServices from '@/services/misc';
import _ from 'lodash';

export default {
  name: 'transactions-table',
  data: () => ({
    amountWidth: 120,
    showJE: false,
    loadingJE: true,
    jeTitle: '',
    jeDetails: null,
    selectedJournalEntry: null,
    uncheckedIds: new Set()
  }),
  props: {
    transactions: {
      required: true
    },
    hideCheckbox: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    accountType () {
      if (this.transactions.length > 0) {
        if (this.transactions[0].account_data.account_type == 'L' || this.transactions[0].account_data.account_type == 'R') {
          return 'CREDIT'
        } else {
          return 'DEBIT'
        }
      }
      return ''
    },
    accountBalance () {
      if (this.transactions.length > 0) {
        if (this.transactions[0].account_data.account_type == 'L' || this.transactions[0].account_data.account_type == 'R') {
          return _.subtract(this.totalCredits, this.totalDebits)
        } else {
          return _.subtract(this.totalDebits, this.totalCredits)
        }
      }
      return 0
    },
    totalJEDebits () {
      if (this.jeDetails) {
        return _.sumBy(this.jeDetails.lines, 'debit')
      }
      return 0
    },
    totalJECredits () {
      if (this.jeDetails) {
        return _.sumBy(this.jeDetails.lines, 'credit')
      }
      return 0
    },
    totalDebits () {
      return _.sumBy(this.transactions, 'debit')
    },
    totalCredits () {
      return _.sumBy(this.transactions, 'credit')
    }
  },
  methods: {
    toggleCheck (id) {
      const next = new Set(this.uncheckedIds)
      next.has(id) ? next.delete(id) : next.add(id)
      this.uncheckedIds = next
    },
    getAmountDisplay (amt) {
      return amt ? this.$options.filters.decAccounting(amt) : '-'
    },
    async openJE (je) {
      console.log("open je");
      this.loadingJE = true;
      this.jeTitle = 'Journal Entry #' + je.id;
      this.jeDetails = await bookkeepingAPI.getJournalEntryLines(je.id);
      this.selectedJournalEntry = je;
      this.showJE = true;
      this.loadingJE = false;
    },
    openInvoice (invID) {
      miscServices.openInNewTab({ name: 'InvoiceOverview', params: { id: invID } })
    },
    openExpense (expID) {
      miscServices.openInNewTab({ name: 'ExpenseOverview', params: { id: expID } })
    }
  },
  components: {
    'je-dialog': JournalEntryDialog
  }
}
</script>
